
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Package, Flame, Gift, Trophy } from 'lucide-react';
import DeliveryBikeAnimation from './DeliveryBikeAnimation';
import HotDealsHeader from './HotDealsHeader';
import NewArrivalsHeader from './NewArrivalsHeader';
import ProductsGrid from './ProductsGrid';
import PopAnimationStyle from './PopAnimationStyle';
import TopCategoriesContent from './TopCategoriesContent';
import TranslatedText from '@/TranslatedText';

// Define the Product interface to match what we're using
interface Product {
  id: string;
  name: string;
  price: number;
  currency: string;
  image: string;
  description: string;
  discount?: number;
  couponCode?: string;
}

interface ProductsTabsProps {
  newArrivals: Product[];
  hotDeals: Product[];
}

const ProductTabs: React.FC<ProductsTabsProps> = ({
  newArrivals,
  hotDeals
}) => {
  return (
    <section className="bg-white w-full">
      {/* Add the animation styles */}
      <PopAnimationStyle />
      
      <div className="w-full px-2 md:px-4 mx-auto overflow-hidden">
        <Tabs defaultValue="new-arrivals" className="w-full">
          <TabsList className="mb-4 bg-gray-100">
            <TabsTrigger value="new-arrivals" className="flex items-center gap-1">
              <Package size={16} />
              <TranslatedText text="New" />
            </TabsTrigger>
            
            <TabsTrigger value="hot-deals" className="flex items-center gap-1">
              <Flame size={16} className="text-red-500" />
              <TranslatedText text="Hot Deals" />
              <Gift size={10} className="text-red-400" style={{
              transformOrigin: 'center',
              animation: 'pop 1.2s ease-in-out infinite'
            }} />
            </TabsTrigger>

            <TabsTrigger value="top-categories" className="flex items-center gap-1">
              <Trophy size={16} className="text-[#0EA5E9]" />
              <TranslatedText text="Top Category" />
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="new-arrivals" className="relative">
            {/* Delivery guy on moto animation */}
            <DeliveryBikeAnimation />
            
            <NewArrivalsHeader />
            
            <ProductsGrid products={newArrivals} />
          </TabsContent>
          
          <TabsContent value="hot-deals" className="relative">
            <HotDealsHeader />
            
            <ProductsGrid products={hotDeals} />
          </TabsContent>

          <TabsContent value="top-categories" className="relative">
            <TopCategoriesContent />
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default ProductTabs;
